export default __webpack_public_path__ + "img/bBeHdCxW.656658b8.svg";